import React, { FC, useState, useMemo, useEffect } from 'react'
import { observer } from 'mobx-react'
import DecorationMobx from '@mobx/app/decoration.mobx'
import { memberMobx, memberCardMobx } from '@mobxStore'
import { GetCardItem, MycardDetailEnter, CardLevelModal } from '@cps'
import { IonSlides, IonSlide, useIonViewWillEnter } from '@ionic/react'
import { useHistoryNew, modalLayer, toast, localStore, getPlatform } from '@utils'
import { format, toPrice } from '@dt/fe-utils'
import { find, findIndex } from '@dt/fe-utils/dist/lodash'
import { checkMCBenifit, getNickName, getGiveAmount, getLevelUpGrowth } from 'common/utils/member'
import mktController from 'controllers/mktController'
import { wxConfigG } from '../../../../../controllers/third'
import './index.scss'

import memberImg from '@img/member/member.png'
import cardBg from '@img/member/card-bg.png'

interface IProps {
  cardId?: string;
}
const { isWeixin, isWeixinMiniProgram } = getPlatform()

const ThreeTempModule: FC<IProps> = (props: IProps) => {
  const { cardId } = props
  const history = useHistoryNew()
  const { mktDecorates } = DecorationMobx
  const { cardList, cardListForMy, memberInfo } = memberMobx
  const { bestDiscountCard } = memberCardMobx
  const [cardShow, setCardShow] = useState<number>(0)
  const [detailType, setDetailType] = useState<boolean>(false)
  const [coverCardInfo, setCoverCardInfo] = useState<any>({})
  const [currCardList, setCurrCardList] = useState<IMemberCardInfo[]>([])
  const cardDropDown = () => {
    if (cardListForMy.length > 0) setCardShow(cardShow < 2 ? 2 : 1)
  }
  const getCardLevel = () => {
    modalLayer(CardLevelModal, { cardInfo: coverCardInfo }).then(() => { }, () => { })
  }
  const handleGo = (url: string) => {
    mktController.checkLogin(history).then(() => {
      history.push(url)
    })
  }
  const getDisCount = () => {
    const nextLevelInfo = coverCardInfo?.card?.nextLevelInfo
    let text = ''
    if (nextLevelInfo) {
      if (nextLevelInfo.discountType) {
        if (nextLevelInfo.discountType === 'discountRate') {
          text = `${i18n.t('order.meals')}${format.toDiscount('discountRate', nextLevelInfo?.discountValue)}`
        } else if (nextLevelInfo.discountType === 'memberPrice') {
          text = `${i18n.t('order.meals')}${i18n.t('checkout.memberPrice')}`
        }
      } else if (nextLevelInfo.mallDiscountType) {
        if (nextLevelInfo.mallDiscountType === 'discountRate') {
          text = `${i18n.t('order.mall')}${format.toDiscount('discountRate', nextLevelInfo?.mallDiscountValue)}`
        } else if (nextLevelInfo.mallDiscountType === 'memberPrice') {
          text = `${i18n.t('order.mall')}${i18n.t('checkout.memberPrice')}`
        }
      }
    }
    return text
  }
  const getCost = () => {
    const levelInfo = coverCardInfo?.card
    let cost = 0
    if (levelInfo) {
      const growth = getLevelUpGrowth(levelInfo.nextLevelInfo.levelGrowth, coverCardInfo.growth)
      if (levelInfo.consumeGrowthGet) {
        cost = growth * levelInfo.consumeGrowth / levelInfo.consumeGrowthGet
      } else if (levelInfo.rechargeGrowthGet) {
        cost = growth * levelInfo.rechargeGrowth / levelInfo.rechargeGrowthGet
      } else if (levelInfo.mallGrowthGet) {
        cost = growth * levelInfo.mallGrowth / levelInfo.mallGrowthGet
      }
    }
    return toPrice(cost, 2)
  }
  const changeAvatar = () => {
    if (memberInfo.type !== 'member') {
      mktController.jumpBind(history, 'all')
    } else {
      handleGo('/my/setting')
    }
  }
  const handleChangeDefault = (card) => () => {
    memberMobx.setDefaultCard({ memberId: card.memberId, memberCardId: card.memberCardId, isDefault: !card.isDefault }).then(() => {
      if (!card.isDefault) {
        localStore.set('diy_card_choosed', card.cardId)
        if (isWeixin && isWeixinMiniProgram) {
          wxConfigG.postMessage({
            type: 'defaultCardId',
            defaultCardId: card.cardId
          })
        }
      }
    })
  }
  const pageCards = useMemo(() => {
    if (currCardList.length > 0 && cardListForMy.length > 0) {
      return currCardList.map((item: any) => {
        return memberMobx.cardListMap[item.cardId] || item
      })
    } else {
      return memberMobx.cardListForMy
    }
  }, [currCardList, memberMobx.cardListForMy])
  const initOpts = {
    initialSlide: findIndex(pageCards, (item) => `${item.cardId}` === cardId) || 0,
    autoplay: false,
    loop: false,
    on: {
      beforeInit () {
        setCoverCardInfo(cardListForMy[0] || {})
      },
      slideChange () {
        const swiper = this as any
        if (cardListForMy && cardListForMy.length) {
          setCoverCardInfo(cardListForMy[swiper.activeIndex])
        }
      }
    }
  }
  useIonViewWillEnter(() => {
    setCurrCardList(cardListForMy)
    setCardShow(0)
  })
  useEffect(() => {
    if (!currCardList.length) {
      setCurrCardList(memberMobx.cardListForMy)
    }
  }, [currCardList, memberMobx.cardListForMy])
  useEffect(() => {
    if (cardId && cardListForMy.length && !memberMobx.hasShowLvInfo) {
      memberMobx.updateHasShowLvInfo(true)
      modalLayer(CardLevelModal, { cardInfo: find(cardListForMy, (item) => `${item.cardId}` === cardId) }).then(() => { }, () => { })
    }
  })
  const { benifitMallRate, benifitMealPrice, benifitMealRate, benifitMallPrice, benifitCoupon } = checkMCBenifit(coverCardInfo.card)
  const cardBtnStyle = { color: mktDecorates.member.cardBenifitColor, backgroundColor: mktDecorates.member?.cardBenifitBgColor }
  const giveAmount = coverCardInfo ? getGiveAmount(coverCardInfo) : ''
  return (
    <div className='three-temp-module'>
      <div className='three-temp-info'>
        <div className='three-temp-left'>
          <div data-cypid='mmgToSetting' onClick={() => handleGo('/my/setting')} className='three-temp-name' style={{ color: mktDecorates.member.fontColor, fontSize: `${mktDecorates.member?.nickFontSize}px` }}>{getNickName(memberInfo?.nickName)}</div>
          {
            memberMobx.isLogin && coverCardInfo?.cardId &&
              <div className='three-temp-discount' style={{ color: mktDecorates.member.cardDiscColor, fontSize: `${mktDecorates.member?.cardDiscSize}px`, backgroundColor: mktDecorates.member.cardDiscBgColor }}>
                {coverCardInfo.card.cardName}
                {benifitMealPrice &&
                  <span>{i18n.t('order.meals')} {i18n.t('checkout.memberPrice')}</span>}
                {
                  benifitMealRate &&
                    <span>{coverCardInfo.card?.products?.length ? i18n.t('mkt.member.someMeals') : i18n.t('order.meals')} {format.toDiscount('discountRate', coverCardInfo.card.discountValue)}</span>
                }
                {
                  benifitMallPrice &&
                    <span>{i18n.t('order.mall')} {i18n.t('checkout.memberPrice')}</span>
                }
                {
                  benifitMallRate && !!coverCardInfo.card.mallDiscountValue &&
                    <span>{coverCardInfo.card?.mallProducts?.length ? i18n.t('mkt.member.someMall') : i18n.t('order.mall')} {format.toDiscount('discountRate', coverCardInfo.card.mallDiscountValue)}</span>
                }
                {benifitCoupon && <span>{i18n.t('mkt.member.couponSend')}</span>}
              </div>
          }
          {
            memberMobx.isLogin && coverCardInfo?.card?.nextLevelInfo &&
              <>
                {
                  getDisCount()
                    ? (
                      <div data-cypid='mmgToMCLevel' className='three-temp-desc' onClick={getCardLevel} style={{ color: mktDecorates.member.cardUpgradeColor, fontSize: `${mktDecorates.member?.cardUpgradeSize}px`, lineHeight: `${mktDecorates.member?.cardUpgradeSize}px` }}>
                        {i18n.t(`mkt.member.${coverCardInfo?.card?.rechargeGrowthGet && !coverCardInfo?.card?.consumeGrowthGet ? 'moreRechargeTip' : 'moreCostTip'}`, { money: getCost(), discount: getDisCount(), cardName: coverCardInfo?.card?.nextLevelInfo.cardName })}{' >>'}
                      </div>
                    ) : (
                      <div data-cypid='mmgToMCLevel' className='three-temp-desc' onClick={getCardLevel} style={{ color: mktDecorates.member.cardUpgradeColor, fontSize: `${mktDecorates.member?.cardUpgradeSize}px`, lineHeight: `${mktDecorates.member?.cardUpgradeSize}px` }}>
                        {i18n.t(`mkt.member.${coverCardInfo?.card?.rechargeGrowthGet && !coverCardInfo?.card?.consumeGrowthGet ? 'moreRechargeNoDisTip' : 'moreCostNoDisTip'}`, { money: getCost(), cardName: coverCardInfo?.card?.nextLevelInfo.cardName })}{' >>'}
                      </div>
                    )
                }
              </>
          }
        </div>
        <div data-cypid='mmgChangeAvatar' className='three-temp-right' style={{ width: `${mktDecorates.member?.avatarSize}px`, height: `${mktDecorates.member?.avatarSize}px` }} onClick={changeAvatar}>
          {
            memberMobx.isLogin ? (
              <>
                {
                  memberInfo.avatarUrl || !memberInfo.nickName ? <div className='avatar-img' style={{ backgroundImage: `Url(${memberInfo.avatarUrl || memberImg})` }}></div> : <div className='avatar-name'>{memberInfo.nickName?.charAt(0)?.toUpperCase()}</div>
                }
              </>
            ) : (
              <div className='avatar-img' style={{ backgroundImage: `Url(${memberImg})` }}></div>
            )
          }
        </div>
      </div>
      {
        memberMobx.isLogin &&
          <div className='three-temp-card'>
            {
              cardList.length === 0 && memberCardMobx.cardList.length > 0 &&
                <div className='guide-area'>
                  {
                    bestDiscountCard && <GetCardItem cardInfo={bestDiscountCard} hasDetail={false}></GetCardItem>
                  }
                </div>
            }
            {
              pageCards.length > 0 &&
                <IonSlides className='card-slides' options={initOpts} key={pageCards.map((item: any) => item.addTime).join('_') + cardId}>
                  {
                    pageCards.map((item: any, index: number) => {
                      return (
                        <IonSlide data-cypid='mmgToMCardItem' key={index} onClick={cardDropDown}>
                          <div
                            data-cypid='mmgToMCardDetail'
                            className='card-area'
                            style={{ color: item.card?.extra?.fontColor || '#B8B8B8' }}
                            onClick={(e: any) => { setDetailType(!detailType) }}
                          >
                            <div className='card-area-item' style={{ backgroundImage: `Url(${item.card?.cover || cardBg})` }}></div>
                            <div className='card-area-row'>
                              <div className='card-area-name'>{item.card?.cardName}</div>
                              <div data-cypid='mmgChooseDefaultMCard' className='card-like' onClick={(e) => { e.stopPropagation(); handleChangeDefault(item)() }}>
                                <i className={`card-like-icon iconfont ${item?.isDefault ? 'icon-like' : 'icon-like1'}`} />
                                {!item?.isDefault && (
                                  <span className='card-like-text'>{i18n.t('mkt.member.memberDefault')}</span>
                                )}
                              </div>
                            </div>
                          </div>
                        </IonSlide>)
                    })
                  }
                </IonSlides>
            }
            {
              detailType && <div className='three-temp-card-detail'><MycardDetailEnter cardInfo={coverCardInfo}></MycardDetailEnter></div>
            }
            {
              coverCardInfo?.cardId &&
                <div className='three-temp-card-info'>
                  {
                    (!!coverCardInfo.balance || coverCardInfo.card?.allowAgainLoad || coverCardInfo.card?.allowCustomizeLoad) &&
                      <div
                        data-cypid='mmgRechargeMCard'
                        onClick={() => {
                          if (coverCardInfo.card.status === 'enable' && (coverCardInfo.card?.allowAgainLoad || coverCardInfo.card?.allowCustomizeLoad)) {
                            handleGo(`/iCard/cardRecharge/${coverCardInfo.memberCardId}`)
                          } else {
                            toast({ message: (coverCardInfo.card?.allowAgainLoad || coverCardInfo.card?.allowCustomizeLoad) ? i18n.t('mkt.member.cardDisableTip') : i18n.t('mkt.member.cardNotRechargeTip') })
                          }
                        }}
                      >
                        <i className='iconfont icon-huabanbeifen'></i>
                        <div className='three-temp-card-tit'>{i18n.t('mkt.common.balance')}</div>
                        <div>{toPrice(coverCardInfo.balance || 0)}</div>
                        <div className={giveAmount ? 'three-temp-card-footer' : ''}>
                          {giveAmount && <span className='three-temp-card-give'>{giveAmount}</span>}
                          <div className='three-temp-card-btn' style={cardBtnStyle}>{i18n.t('mkt.member.rechargeBalance')}</div>
                        </div>
                      </div>
                  }
                  {
                    !!coverCardInfo.card?.isIntegral &&
                      <div data-cypid='mmgToReem' onClick={() => { handleGo(`/redeem/${coverCardInfo.cardId}`) }}>
                        <i className='iconfont icon-huaban21'></i>
                        <div className='three-temp-card-tit'>{i18n.t('mkt.common.integral')}</div>
                        <div>{coverCardInfo.integral || 0}</div>
                        <div className={giveAmount ? 'three-temp-card-footer' : ''}>
                          <div className='three-temp-card-btn' style={cardBtnStyle}>{i18n.t('mkt.coupon.exchange')}</div>
                        </div>
                      </div>
                  }
                  {
                    !!memberMobx.couponListForUse.length &&
                      <div data-cypid='mmgToMyCoupon' onClick={() => { handleGo('/iCoupon/coupon/my') }}>
                        <i className='iconfont icon-a-huabanbeifen21'></i>
                        <div className='three-temp-card-tit'>{i18n.t('cart.coupons')}</div>
                        <div>{i18n.t('mkt.coupon.couponNum', { cnt: memberMobx.couponListForUse.length })}</div>
                        <div className={giveAmount ? 'three-temp-card-footer' : ''}>
                          <div className='three-temp-card-btn' style={cardBtnStyle}>{i18n.t('mkt.coupon.cardCoupon')}</div>
                        </div>
                      </div>
                  }
                </div>
            }
          </div>
      }
    </div>
  )
}

export default observer(ThreeTempModule)
